import { cn } from "@/lib/utils";
import logoSquare from "@/assets/logos/squared/innflow_square_web_200x200.png";
import logoNavbar from "@/assets/logos/horizontal/innflow_navbar_240x60@2x.png";

interface LoadingLogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "horizontal" | "vertical" | "square" | "icon";
  className?: string;
}

const logoPaths = {
  horizontal: {
    navbar: logoNavbar,
  },
  squared: {
    icon: logoSquare,
  },
};

const sizeMap = {
  sm: 32,
  md: 48,
  lg: 64,
  xl: 80,
};

export function LoadingLogo({ 
  size = "md", 
  variant = "square",
  className 
}: LoadingLogoProps) {
  const imgSize = sizeMap[size];

  const getLogoSrc = () => {
    if (variant === "horizontal") {
      return logoPaths.horizontal.navbar;
    }
    return logoPaths.squared.icon;
  };

  return (
    <div className={cn("flex items-center justify-center", className)}>
      <div className="relative">
        <img 
          src={getLogoSrc()}
          alt="INNFLOW"
          className="animate-[logoSpin_2s_ease-in-out_infinite,logoPulse_2s_ease-in-out_infinite]"
          style={{
            width: `${imgSize}px`,
            height: `${imgSize}px`,
            objectFit: 'contain',
            filter: "drop-shadow(0 0 12px rgba(16, 185, 129, 0.6))",
          }}
        />
        <div className="absolute inset-0 rounded-full bg-emerald-500/30 blur-2xl animate-ping" />
        <style>{`
          @keyframes logoSpin {
            0%, 100% { 
              transform: rotate(0deg) scale(1);
            }
            25% { 
              transform: rotate(5deg) scale(1.1);
            }
            50% { 
              transform: rotate(0deg) scale(1.2);
            }
            75% { 
              transform: rotate(-5deg) scale(1.1);
            }
          }
          @keyframes logoPulse {
            0%, 100% { 
              opacity: 1;
            }
            50% { 
              opacity: 0.8;
            }
          }
        `}</style>
      </div>
    </div>
  );
}
